import date from 'date-and-time';

export function getStartDayOfAnniversary() {
  return date.parse(`05-07-${new Date().getUTCFullYear()}`, 'DD-MM-YYYY', true);
}
export function getFinalDayOfAnniversary() {
  return date.parse(`08-07-${new Date().getUTCFullYear()}`, 'DD-MM-YYYY', true);
}
